// 合同治理路由 (菜单 link: /contractAdmin/* 顶级路径, 与 sudu_privilege 行对应)
// meta.privilege: 路由级权限校验, 对齐后端 contractAdminSess 用的 sudu_privilege link
// (详情页复用列表页权限 uri; rule/audit 页面复用"规则审核"按钮权限行)
export default {
    path: '/contractAdmin',
    component: () => import('@/layout/manage'),
    redirect: '/contractAdmin/template',
    meta: {
        requireAuth: true,
    },
    children: [
        {
            path: 'template',
            name: 'contractAdminTemplate',
            component: () => import('@/views/manage/contractAdmin/template'),
            meta: { privilege: '/contractAdmin/template' },
        },
        {
            path: 'rule',
            name: 'contractAdminRule',
            component: () => import('@/views/manage/contractAdmin/rule'),
            meta: { privilege: '/contractAdmin/rule' },
        },
        {
            path: 'rule/audit',
            name: 'contractAdminRuleAudit',
            component: () => import('@/views/manage/contractAdmin/rule-audit'),
            meta: { privilege: '/contractAdmin/rule/audit' },
        },
        {
            path: 'company',
            name: 'contractAdminCompany',
            component: () => import('@/views/manage/contractAdmin/company'),
            meta: { privilege: '/contractAdmin/company' },
        },
        {
            path: 'company/detail',
            name: 'contractAdminCompanyDetail',
            component: () => import('@/views/manage/contractAdmin/company-detail'),
            meta: { privilege: '/contractAdmin/company' },
        },
        {
            path: 'contract',
            name: 'contractAdminContract',
            component: () => import('@/views/manage/contractAdmin/contract'),
            meta: { privilege: '/contractAdmin/contract' },
        },
        {
            path: 'contract/detail',
            name: 'contractAdminContractDetail',
            component: () => import('@/views/manage/contractAdmin/contract-detail'),
            meta: { privilege: '/contractAdmin/contract' },
        },
        {
            path: 'rebind',
            name: 'contractAdminRebind',
            component: () => import('@/views/manage/contractAdmin/rebind'),
            meta: { privilege: '/contractAdmin/rebind' },
        },
        {
            path: 'gray',
            name: 'contractAdminGray',
            component: () => import('@/views/manage/contractAdmin/gray'),
            meta: { privilege: '/contractAdmin/gray' },
        },
        {
            // P2-1 历史收款迁移: 菜单 link /contractAdmin/migration (sudu_privilege id=1000171)
            path: 'migration',
            name: 'contractAdminMigration',
            component: () => import('@/views/manage/contractAdmin/migration'),
            meta: { privilege: '/contractAdmin/migration' },
        },
    ],
};
